export default "__VITE_ASSET__B9u$t$Xa__"